export default function (cli) {
  return {
    getDepartments () {
      return cli.get(`${cli.crmApiEndpoint}departments/`).query()
    },
    addDepartment (data) {
      return cli.post(`${cli.crmApiEndpoint}departments/`).send(data)
    },
    editDepartment (data) {
      return cli.patch(`${cli.crmApiEndpoint}departments/${data.pk}/`).send(data)
    },
    deleteDepartment (pk) {
      return cli.del(`${cli.crmApiEndpoint}departments/${pk}/`).send()
    },
    updateListOrder (data) {
      return cli.post(`${cli.crmApiEndpoint}departments/update-list-order/`).send(data)
    },
  }
}



// WEBPACK FOOTER //
// ./src/api/crm/departments.js